import EmblaCarousel from 'embla-carousel';
import { addThumbBtnsClickHandlers, addToggleThumbBtnsActive } from './emblaSliderThumbs';
import { addPrevNextBtnsClickHandlers } from './emblaSliderArrows';

export default class ProductImageGallery {
  constructor(app) {
    this.app = app;
    this.init = this.init.bind(this);

    this.init();
  }

  init() {
    const OPTIONS = {};
    const OPTIONS_THUMBS = {
      containScroll: 'keepSnaps',
      dragFree: true,
    };

    const emblaNodes = document.querySelectorAll('.js-product-image-gallery.js-embla');
    emblaNodes.forEach((emblaNode) => {
      const viewportNodeMainCarousel = emblaNode.querySelector('.js-embla__view');
      const viewportNodeThumbCarousel = emblaNode.querySelector('.js-embla-thumbs__view');

      const emblaApiMain = EmblaCarousel(viewportNodeMainCarousel, OPTIONS);
      const emblaApiThumb = EmblaCarousel(viewportNodeThumbCarousel, OPTIONS_THUMBS);

      const prevBtn = emblaNode.querySelector('.js-embla-button--prev');
      const nextBtn = emblaNode.querySelector('.js-embla-button--next');

      const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(emblaApiMain, emblaApiThumb);
      const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(emblaApiMain, emblaApiThumb);
      const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApiMain, prevBtn, nextBtn);

      emblaApiMain
        .on('destroy', removeThumbBtnsClickHandlers)
        .on('destroy', removeToggleThumbBtnsActive)
        .on('destroy', removePrevNextBtnsClickHandlers);

      emblaApiThumb.on('destroy', removeThumbBtnsClickHandlers).on('destroy', removeToggleThumbBtnsActive);
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/productImageGallery.js